module.exports = __webpack_public_path__ + "img/logo-AI-kasa-negativ.fa8ba0e5.svg";